import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const registrationBaseUrl = '/api/registration';

export const registrationApi = createApi({
  reducerPath: 'registrationApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    createSession: builder.mutation<string, number>({
      query: (locationId) => ({
        url: `${registrationBaseUrl}/session/${locationId}`,
        method: 'POST',
      }),
    }),
    saveRegistration: builder.mutation<CheckinSelfRegisterData, RegistrationPayload>({
      query: (body) => ({
        url: registrationBaseUrl,
        method: 'POST',
        body,
      }),
    }),
    getSession: builder.query<SessionResponse, string>({
      query: (sessionId) => ({
        url: `${registrationBaseUrl}/session_id/${sessionId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useCreateSessionMutation, useLazyGetSessionQuery, useSaveRegistrationMutation } =
  registrationApi;
